<table mat-table [dataSource]="groupedExpenses" class="w-full min-w-500 mat-elevation-z">
    <!-- Motivo de gasto -->
    <ng-container matColumnDef="reasonName">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
            Motivo de gasto
        </th>
        <td mat-cell *matCellDef="let row" class="px-6 text-left">
            <div class="flex items-center gap-2">
                <button *ngIf="showActions" mat-icon-button matTooltip="Ver historial"
                    (click)="openHistoryModal(row.reasonName)">
                    <mat-icon>open_in_new</mat-icon>
                </button>
                <span>{{ row.reasonName }}</span>
            </div>
        </td>
        <td mat-footer-cell *matFooterCellDef class="px-6 text-left font-bold">
            TOTAL
        </td>
    </ng-container>

    <!-- Total monto -->
    <ng-container matColumnDef="totalAmount">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-right">
            Monto ({{ totalUnit }})
        </th>
        <td mat-cell *matCellDef="let row" class="px-6 text-right">
            {{ row.totalAmount | number : '1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="px-6 text-right font-bold">
            {{ totalGeneral | number: '1.2-2' }}
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="border-b"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns" class="bg-gray-50 dark:bg-gray-800 font-bold"></tr>
</table>


<ng-template #detailModal>
        <mat-dialog-content class="modal-content">
          <app-expense-load-list [tripId]="tripId" [expenseReasonName]="reasonNameGlobal" [total]="totalGeneral"></app-expense-load-list>
        </mat-dialog-content>
        <mat-dialog-actions class="modal-actions flex justify-end">
          <button mat-button mat-dialog-close class="align-left">Cerrar</button>
          </mat-dialog-actions>
        </ng-template>